'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import YandexReviewsIframeSkeleton from './YandexReviewsIframeSkeleton';

const YandexReviewsIframe = dynamic(() => import('./YandexReviewsIframe'), {
  ssr: false,
  loading: () => <YandexReviewsIframeSkeleton />,
});

export default function ServiceReviews() {
  return (
    <section className="px-8 py-8 md:py-12 lg:py-16 bg-slate-50 dark:bg-slate-900 rounded-2xl">
      <div className="mb-8 md:mb-12 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">
          Отзывы наших клиентов
        </h2>
        <p className="text-gray-600 dark:text-gray-400 text-base md:text-lg max-w-2xl mx-auto">
          Что говорят о нас заказчики
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 items-start">
        <div className="flex-1 content text-gray-700 dark:text-gray-300 text-base md:text-lg leading-relaxed">
          Мы всегда стремимся улучшить наш сервис и производство. Ваши отзывы помогут нам лучше понять ваши потребности, любые пробелы в нашем магазине, а также определить приоритетные области для улучшения.
          <br />
          <br />
          <div className="font-bold">
            Вы можете оставить отзыв на сайте или на{' '}
            <a
              href="https://yandex.ru/maps/org/uralmetall/1648964365/reviews/?add-review=true"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 hover:underline"
            >
              яндекс картах
            </a>
          </div>
        </div>

        <YandexReviewsIframe />
      </div>
    </section>
  );
}

